import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { GenericList } from './models/generic-list';
import { MaintVehicle } from './models/maint-vehicle';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/maint/vehicles';

/**
 * [システム] [メンテナンス] 車両 のプロバイダー.
 */
@Injectable()
export class SystemMaintVehiclesServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * 車両一覧取得処理.
   * 
   * @returns Observable<GenericList<MaintVehicle>>
   */
  list(): Observable<GenericList<MaintVehicle>> {
    return this.servicer.list(BASE_URL);
  }

  /**
   * 車両取得処理.
   * 
   * @param id 車両ID
   * @returns Observable<MaintVehicle>
   */
  get(id: number): Observable<GenericItem<MaintVehicle>> {
    const url = `${ BASE_URL }/${ id }`;
    return this.servicer.get<GenericItem<MaintVehicle>>(url);
  }

  /**
   * 車両保存処理.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  patch(data: MaintVehicle): Observable<ApiResponse> {
    const url = `${ BASE_URL }/${ data.id }`;
    return this.servicer.patch<MaintVehicle, ApiResponse>(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-maint-vehicles-service.ts